import { Dispatch, SetStateAction } from 'react';

import { Modal } from 'coreOld/components';
import { Size } from 'coreOld/enums';

import ChooseManufacturerTable from './ChooseManufacturerTable';
import { filtersConfig } from './configs';

interface IProps {
  isOpen: boolean;
  isModalOpen: boolean;
  onClose: () => void;
  importId: number;
  setIsUnknownManufactures: Dispatch<SetStateAction<boolean>>;
  refetchColumns;
}

const ChooseManufacturerModalView = ({
  isOpen,
  onClose,
  importId,
  isModalOpen,
  refetchColumns,
  setIsUnknownManufactures,
}: IProps) => {
  return (
    <Modal title={'Choose Manufacturer'} isOpen={isOpen} onClose={onClose} size={Size.XL}>
      <ChooseManufacturerTable
        filtersConfig={filtersConfig()}
        importId={importId}
        isModalOpen={isModalOpen}
        onClose={onClose}
        refetchColumns={refetchColumns}
        setIsUnknownManufactures={setIsUnknownManufactures}
      />
    </Modal>
  );
};

export default ChooseManufacturerModalView;
